import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from 'react-share';

import { Modal } from '../../components';
import copyIcon from '../../assets/copy.svg';
import css from './ShareModal.css';

const ShareModal = props => {
  const { shareModalOpen, onShareModalClose, onManageDisableScrolling } = props;
  const [copiedLink, setCopiedLink] = useState(false);
  const [canRender, setCanRender] = useState(false);
  useEffect(() => {
    setCanRender(true);
  });
  if (!canRender) return null;

  const handleClickCopyLink = () => {
    setCopiedLink(true);
    setTimeout(() => {
      setCopiedLink(false);
    }, 5000);
    return () => clearTimeout();
  };
  const shareUrl = window.location.href;
  const shareUrlforFacebook = shareUrl.replace('?share=true', '');
  const swimmyPrimaryColorFillIcon = { fill: '#07a0f2' };
  const iconSize = 32;
  const copyLink = !copiedLink
    ? <FormattedMessage id="ShareModal.copyLink"/>
    : <FormattedMessage id="ShareModal.copiedLink"/>;

  return (
    <Modal
      id="ShareModal"
      containerClassName={css.shareModalContainer}
      contentClassName={css.shareModalContent}
      isOpen={shareModalOpen}
      onClose={onShareModalClose}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <div className={css.shareModalTitle}>
        <FormattedMessage id="ShareModal.title"/>
      </div>
      <FacebookShareButton url={shareUrlforFacebook} className={css.shareButton}>
        <FacebookIcon size={iconSize} round bgStyle={swimmyPrimaryColorFillIcon}/>
        <div className={css.shareButtonName}>
          <FormattedMessage id="ShareModal.facebook"/>
        </div>
      </FacebookShareButton>
      <WhatsappShareButton url={shareUrl} className={css.shareButton}>
        <WhatsappIcon size={iconSize} round bgStyle={swimmyPrimaryColorFillIcon}/>
        <div className={css.shareButtonName}>
          <FormattedMessage id="ShareModal.whatsApp"/>
        </div>
      </WhatsappShareButton>
      <EmailShareButton url={shareUrl} className={css.shareButton}>
        <EmailIcon size={iconSize} round bgStyle={swimmyPrimaryColorFillIcon}/>
        <div className={css.shareButtonName}>
          <FormattedMessage id="ShareModal.email"/>
        </div>
      </EmailShareButton>
      <CopyToClipboard text={shareUrl} onCopy={handleClickCopyLink}>
        <div className={css.shareButton}>
          <img src={copyIcon}/>
          <div className={css.shareButtonName}>
            {copyLink}
          </div>
        </div>
      </CopyToClipboard>
    </Modal>
  );
};

ShareModal.propTypes = {
  shareModalOpen: bool,
  onShareModalClose: func.isRequired,
  onManageDisableScrolling: func,
  intl: intlShape.isRequired,
};

export default injectIntl(ShareModal);



// WEBPACK FOOTER //
// ./src/components/ShareModal/ShareModal.js